import { render, staticRenderFns } from "./Template1.vue?vue&type=template&id=345e0fde"
import script from "./Template1.vue?vue&type=script&lang=js"
export * from "./Template1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports